import { IncreaseCreditLimitNZParam } from "components/IncreaseCreditLimit/NzForm";
import {
  frequencyOptionsNz,
  increaseCreditLimitCustomFieldsNZ,
} from "../customFieldsMap";
import {
  additionalIncomeFrequency,
  employmentStatusOptions,
  incomeReduction,
  loanCommitments,
  lumpSumPayment,
  savingsForLumpSum,
} from "../customFieldsMap/increaseCreditLimitCustomFieldsMap";
import { formatDate } from "../zendeskAPI";

const FORM_ID_NZ = { prod: 360000882177, nonProd: 360002912618 };

const GROUP_ID_NZ = { prod: 360002369658, nonProd: 360004390538 };

export const formatPayload = (
  fields: IncreaseCreditLimitNZParam,
  envKey: "prod" | "nonProd",
) => ({
  isNZ: true,
  requester: {
    name: fields.userName,
    email: fields.email,
  },
  ticketFormId: FORM_ID_NZ[envKey],
  groupId: GROUP_ID_NZ[envKey],
  subject: "Increase credit limit",
  comment:
    "Increase credit limit request originating from the Latitude Service Centre (LSC).",
  customFields: [
    {
      id: increaseCreditLimitCustomFieldsNZ["Customers first name"],
      value: fields.firstName,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Surname  (as it appears on ID)"],
      value: fields.lastName,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ.DOB,
      value: formatDate(fields.dateOfBirth),
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Mobile Number"],
      value: fields.mobileNumber,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Last 4 digits"],
      value: fields.last4digits,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Card type NZ"],
      value: fields.cardType,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["New Limit"],
      value: fields.newCreditLimit,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Personal Relationship Status"],
      value: fields.maritalStatus,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ.Dependants,
      value: fields.dependants,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Total Income"],
      value: fields.totalIncome.amount,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Total Amount Owing - NZ CLI"],
      value: fields.nzTotalOwing,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Loan Commitments - NZ CLI"],
      value: loanCommitments[fields.nzLoanCommitmentsChanged][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Lump sum payment - NZ CLI"],
      value: lumpSumPayment[fields.nzIntendLumpSum][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Savings for Lump Sum - NZ CLI"],
      value: savingsForLumpSum[fields.nzIncludeLumpSum][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Total expenses monthly - NZ CLI"],
      value: fields.nzTotalExpenses,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ[
        "Generic Additional Expense - NZ CLI"
      ],
      value: fields.nzAnyAdditionalExpense,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Fitness/Medical - NZ CLI"],
      value: fields.nzPersonalFitnessMedical,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Education/Childcare - NZ CLI"],
      value: fields.nzEducationChildcare,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Transport - NZ CLI"],
      value: fields.nzTransportAuto,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["General Insurance - NZ CLI"],
      value: fields.nzGeneralInsurance,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Utilities & Expenses - NZ CLI"],
      value: fields.nzOtherPropertyExpenses,
    },
    // {
    //   id: increaseCreditLimitCustomFieldsNZ["Property Rates - NZ CLI"],
    //   value: fields.nzPropertyRates,
    // },
    // {
    //   id: increaseCreditLimitCustomFieldsNZ[
    //     "Secondary Property Mortgage/Rent/Board - NZ CLI"
    //   ],
    //   value: fields.nzSecondaryMortgage,
    // },
    {
      id: increaseCreditLimitCustomFieldsNZ["Housing Costs Changed - NZ CLI"],
      value: fields.nzHousingCosts,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Revolving Mortgage - NZ CLI"],
      value: fields.nzRevolvingMortgage,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Household Expenses - NZ CLI"],
      value: fields.nzAllExpensesForHousehold,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ[
        "Food/Groceries/Entertainment - NZ CLI"
      ],
      value: fields.nzFoodGroceriesEntertainment,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Employment Status - NZ CLI"],
      value: employmentStatusOptions[fields.nzEmploymentStatus][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Additional Income - NZ CLI"],
      value: fields.totalIncome.amount,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Additional Income Frequency"],
      value: additionalIncomeFrequency[fields.totalIncome.frequency][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Payment Frequency WFM - 1"],
      value:
        frequencyOptionsNz["Payment Frequency WFM - 1"][
          fields.totalIncome.frequency
        ][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Total Limit On Credit Card"],
      value: fields.totalLimit,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Expense: Other Loans"],
      value: fields.expenses.amount,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Payment Frequency WFM"],
      value:
        frequencyOptionsNz["Payment Frequency WFM"][fields.expenses.frequency][
          envKey
        ],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Income Reduction - NZ CLI"],
      value: incomeReduction[fields.nzIncomeChangesInFuture][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Expense: Other Loans"],
      value: fields.otherExpenses.amount,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Payment Frequency WFM - 2"],
      value:
        frequencyOptionsNz["Payment Frequency WFM - 2"][
          fields.otherExpenses.frequency
        ][envKey],
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Preferred Contact Method"],
      value: fields.communicationMethod,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Personal Insurance - NZ CLI"],
      value: fields.nzPersonalInsurance,
    },
    {
      id: increaseCreditLimitCustomFieldsNZ["Privacy Acknowledgement"],
      value: fields.iConfirm && fields.discloseCredit && fields.correctInfo,
    },
  ],
});
